const infoRows = [
  { label: "内容形式", value: "以连续剧集为主，也可能存在短片或合集版本" },
  { label: "常见需求", value: "观看入口、全集、完整版本、网盘下载" },
  { label: "搜索特征", value: "标题较长，常与“在哪看 / 资源 / 地址”等词组合" },
  { label: "本站定位", value: "只做渠道整理与观看指引，不存放、不传播任何影视内容" },
];

export default function Overview() {
  return (
    <section id="overview" className="w-full scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-7">
          <span className="text-xs font-semibold tracking-[0.2em] text-accent-700">OVERVIEW / 作品简介</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于「继母的诱惑」与本站定位
          </h2>

          <div className="mt-6 space-y-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            <p>
              <strong className="font-semibold text-foreground-900">「继母的诱惑」</strong>
              是近期检索量较高的一类影视内容关键词。围绕它展开的搜索，绝大多数都集中在同一个问题上——
              到底在哪里才能看到，有没有全集，哪个渠道比较稳定。
            </p>
            <p>
              这类诉求本身并不复杂，真正麻烦的是信息过于分散：正规平台、电视台客户端、海外站点、
              社区帖子、网盘分享……每换一处，规则和稳定性都不一样。本站的作用，就是把常见的渠道类型
              与查找思路整理在同一页里，让你少走弯路。
            </p>
            <p>
              需要说明的是，同一标题在不同平台可能对应不同的版本（剧集、短片或合集），页面之间也可能存在
              剪辑差异。因此本页提供的是方向性指引，具体内容请以你实际打开的平台信息为准。
            </p>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-xl border border-background-200 bg-background-100 p-6 md:p-7">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-information-2-line text-lg"></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">快速了解</h3>
            </div>

            <dl className="mt-6 space-y-4">
              {infoRows.map((row) => (
                <div key={row.label} className="border-t border-background-200 pt-4 first:border-t-0 first:pt-0">
                  <dt className="text-xs tracking-wide text-foreground-500">{row.label}</dt>
                  <dd className="mt-1 text-sm font-medium leading-relaxed text-foreground-800">{row.value}</dd>
                </div>
              ))}
            </dl>

            <p className="mt-6 rounded-lg bg-accent-100/70 px-4 py-3 text-xs leading-relaxed text-accent-900">
              提示：本站不提供任何影片文件或可播放链接，所有内容均为渠道信息整理，请在合法合规的前提下观看。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}